import form from "./form";

const {
  formField: {
    name,
    description,
    clientId,
    budget,
    actualExpenditure,
    startedDate,
    endedDate,
    budgetStatus,
    projectStatus,
    categoryId,
    progress,
    changeRequestCount,
    file,
    companyId,
  },
} = form;

const initialValues = {
  [name.name]: "",
  [description.name]: "",
  [clientId.name]:"",
  [budget.name]: 0,
  [actualExpenditure.name]: 0,
  [startedDate.name]: new Date().toISOString().slice(0, 10),
  [endedDate.name]: new Date().toISOString().slice(0, 10),
  [budgetStatus.name]: 0,
  [projectStatus.name]: "",
  [categoryId.name]:"",
  [progress.name]: 0,
  [changeRequestCount.name]: 0,
  [file.name]: null,
  [companyId.name]:"",
};

export default initialValues;
